module.exports = "/_next/static/images/intercom_logo-d6ca62af065fca05845db3de491babf0.png";